import React from 'react'
import VideoJS from '../utilities/VideoJS'
const Video = ({videoURL, altText, poster, pauseVid}) => {
    const playerRef = React.useRef(null);

    const videoJsOptions = { // lookup the options in the docs for more options
        autoplay: false,
        controls: true,
        responsive: true,
        fluid: true,
        poster: poster,
        sources: [{
        src: videoURL,
        type: 'video/mp4'
        }]
    }

    const handlePlayerReady = (player) => {
        playerRef.current = player;

        // you can handle player events here
        player.on('waiting', () => {
        console.log('player is waiting');
        });

        player.on('dispose', () => {
        console.log('player will dispose');
        });

    };

   
    return (
        <div>
              <VideoJS options={videoJsOptions} onReady={handlePlayerReady} />
        </div>
    )
}


export default Video
